import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { useConfigStore } from '@/stores/configStore';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface HelpPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

export function HelpPopup({ isOpen, onClose }: HelpPopupProps) {
    const { t } = useTranslation();
    const { config } = useConfigStore();
    const descFromStore = config?.ui?.requestStaffHelp?.desc?.trim() ?? '';

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="max-w-[calc(680*var(--vw-unit))]" closeTabIndex={3} closeRegionOrder={3}>
            <h1 className={clsx(styles.helpModal__title)}>
                <span data-modal-region tabIndex={0} data-interactive aria-label={t('employeeHelp.header')} className="focus-border">
                    {t('employeeHelp.header')}
                </span>
            </h1>
            <div className={styles.helpModal__contentContainer}>
                <p
                    tabIndex={1}
                    className={clsx(styles.helpModal__description, 'text-text-main01', 'focus-border')}
                    data-interactive
                    aria-label={t('employeeHelp.descriptionTTS')}
                    dangerouslySetInnerHTML={{ __html: t('employeeHelp.description') }}
                    data-modal-region
                    data-modal-region-order={1}
                ></p>
                <div
                    tabIndex={1}
                    className={clsx(config.ui.contrast ? styles['helpModal__phoneContainer--contrast'] : styles['helpModal__phoneContainer'], 'focus-border')}
                    data-interactive
                    aria-label={descFromStore}
                    data-modal-region
                    data-modal-region-order={2}
                >
                    <span className={clsx('number', config?.ui?.contrast ? styles['helpModal__phoneNumber--contrast'] : styles.helpModal__phoneNumber)}>
                        <span dangerouslySetInnerHTML={{ __html: descFromStore }} />
                    </span>
                </div>
            </div>

            <div className={styles.helpModal__buttonContainer}>
                <ModalButton
                    role="button"
                    variant="primary"
                    onClick={onClose}
                    data-interactive
                    aria-label={t('employeeHelp.text.confirmButton')}
                    type="button"
                    tabIndex={2} data-modal-region data-modal-region-order={2}
                >
                    {t('employeeHelp.text.confirmButton')}
                </ModalButton>
            </div>
        </Modal>
    );
}
